"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _default = function _default(theme) {
  return {
    root: {
      borderBottom: "1px solid ".concat(theme.colors.placeholders),
      '& .hoi-poi-ui__tabs': {
        boxSizing: 'border-box',
        position: 'relative',
        overflow: 'hidden'
      },
      '& .hoi-poi-ui__tabs-bar, & .hoi-poi-ui__tabs-nav-container': {
        fontSize: '14px',
        lineHeight: '1.5',
        boxSizing: 'border-box',
        overflow: 'hidden',
        position: 'relative',
        whiteSpace: 'nowrap',
        outline: 'none',
        zoom: 1,
        transition: 'padding .45s'
      },
      '& .hoi-poi-ui__tabs-ink-bar': {
        zIndex: 1,
        position: 'absolute',
        boxSizing: 'border-box',
        marginTop: '-3px',
        backgroundColor: theme.colors.primary,
        transformOrigin: '0 0',
        width: 0,
        height: 0
      },
      '& .hoi-poi-ui__tabs-tab-prev, & .hoi-poi-ui__tabs-tab-next': {
        WebkitUserSelect: 'none',
        MozUserSelect: 'none',
        MsUserSelect: 'none',
        userSelect: 'none',
        zIndex: 1,
        lineHeight: '30px',
        cursor: 'pointer',
        border: 'none',
        backgroundColor: 'transparent',
        position: 'absolute',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        overflow: 'hidden'
      },
      '& .hoi-poi-ui__tabs-tab-prev-icon, & .hoi-poi-ui__tabs-tab-next-icon': {
        position: 'relative',
        display: 'inline-block',
        fontStyle: 'normal',
        fontWeight: 'normal',
        fontVariant: 'normal',
        lineHeight: 'inherit',
        verticalAlign: 'baseline',
        textAlign: 'center',
        textTransform: 'none',
        fontSmoothing: 'antialiased',
        textStrokeWidth: 0,
        fontFamily: 'sans-serif'
      },
      '& .hoi-poi-ui__tabs-tab-prev-icon:before, & .hoi-poi-ui__tabs-tab-next-icon:before': {
        display: 'block'
      },
      '& .hoi-poi-ui__tabs-tab-btn-disabled, & .hoi-poi-ui__tabs-tab-arrow-show.hoi-poi-ui__tabs-tab-btn-disabled': {
        cursor: 'default',
        color: '#ccc',
        opacity: '0.5 !important'
      },
      '& .hoi-poi-ui__tabs-nav-wrap': {
        overflow: 'hidden'
      },
      '& .hoi-poi-ui__tabs-nav': {
        boxSizing: 'border-box',
        paddingLeft: 0,
        position: 'relative',
        margin: 0,
        float: 'left',
        listStyle: 'none',
        display: 'inline-block',
        transformOrigin: '0 0'
      },
      '& .hoi-poi-ui__tabs-nav-animated': {
        transition: 'transform 0.5s cubic-bezier(0.35, 0, 0.25, 1)'
      },
      '& .hoi-poi-ui__tabs-nav:before': {
        display: 'table',
        content: '" "'
      },
      '& .hoi-poi-ui__tabs-nav:after': {
        clear: 'both'
      },
      '& .hoi-poi-ui__tabs-tab': (0, _extends2.default)({
        boxSizing: 'border-box',
        position: 'relative',
        display: 'block',
        transition: 'color 0.3s cubic-bezier(0.35, 0, 0.25, 1)',
        padding: '5px 0',
        lineHeight: '20px',
        cursor: 'pointer'
      }, theme.typography.smallText, {
        textTransform: 'uppercase',
        fontWeight: '500',
        color: theme.colors.text.greySoft,
        outline: 'none'
      }),
      '& .hoi-poi-ui__tabs-tab:hover': {
        color: theme.colors.primary
      },
      '& .hoi-poi-ui__tabs-tab-active, & .hoi-poi-ui__tabs-tab-active:hover': {
        color: theme.colors.primary,
        cursor: 'default',
        transform: 'translateZ(0)'
      },
      '& .hoi-poi-ui__tabs-tab-disabled, & .hoi-poi-ui__tabs-tab-disabled:hover': {
        cursor: 'default',
        color: '#ccc'
      },
      '& .hoi-poi-ui__tabs-content': {
        zoom: 1
      },
      '& .hoi-poi-ui__tabs-content .hoi-poi-ui__tabs-tabpane': {
        overflow: 'auto'
      },
      '& .hoi-poi-ui__tabs-content-animated': {
        transition: 'margin-left 0.3s cubic-bezier(0.35, 0, 0.25, 1), margin-top 0.3s cubic-bezier(0.35, 0, 0.25, 1)',
        display: 'flex',
        willChange: 'transform'
      },
      '& .hoi-poi-ui__tabs-content-animated .hoi-poi-ui__tabs-tabpane': {
        MsFlexNegative: 0,
        flexShrink: 0
      },
      '& .no-flexbox .hoi-poi-ui__tabs-content': {
        transform: 'none !important',
        overflow: 'auto'
      },
      '& .no-csstransitions .hoi-poi-ui__tabs-tabpane-inactive': {
        display: 'none'
      },
      '& .no-flexbox .hoi-poi-ui__tabs-tabpane-inactive': {
        display: 'none'
      },
      '& .hoi-poi-ui__tabs-content-no-animated .hoi-poi-ui__tabs-tabpane-inactive': {
        display: 'none'
      },
      '& .hoi-poi-ui__tabs-left': {
        borderRight: "2px solid ".concat(theme.colors.placeholders)
      },
      '& .hoi-poi-ui__tabs-left .hoi-poi-ui__tabs-bar': {
        float: 'left',
        height: '100%',
        marginRight: '10px'
      },
      '& .hoi-poi-ui__tabs-left .hoi-poi-ui__tabs-nav-container': {
        height: '100%'
      },
      '& .hoi-poi-ui__tabs-left .hoi-poi-ui__tabs-nav-container-scrolling': {
        paddingTop: '32px',
        paddingBottom: '32px'
      },
      '& .hoi-poi-ui__tabs-left .hoi-poi-ui__tabs-nav-wrap': {
        height: '100%'
      },
      '& .hoi-poi-ui__tabs-left .hoi-poi-ui__tabs-content-animated': {
        MsFlexDirection: 'column',
        flexDirection: 'column'
      },
      '& .hoi-poi-ui__tabs-left .hoi-poi-ui__tabs-content-animated .hoi-poi-ui__tabs-tabpane': {
        height: '100%'
      },
      '& .hoi-poi-ui__tabs-left .hoi-poi-ui__tabs-nav-scroll': {
        height: '99999px'
      },
      '& .hoi-poi-ui__tabs-left .hoi-poi-ui__tabs-nav-swipe': {
        position: 'relative',
        top: 0
      },
      '& .hoi-poi-ui__tabs-left .hoi-poi-ui__tabs-nav-swipe .hoi-poi-ui__tabs-nav': {
        display: 'flex',
        MsFlex: 1,
        flex: 1,
        MsFlexDirection: 'column',
        flexDirection: 'column',
        height: '100%'
      },
      '& .hoi-poi-ui__tabs-left .hoi-poi-ui__tabs-nav-swipe .hoi-poi-ui__tabs-nav .hoi-poi-ui__tabs-tab': {
        display: 'flex',
        MsFlexNegative: 0,
        flexShrink: 0,
        MsFlexPack: 'center',
        justifyContent: 'center'
      },
      '& .hoi-poi-ui__tabs-left .hoi-poi-ui__tabs-tab-prev': {
        top: '2px !important'
      },
      '& .hoi-poi-ui__tabs-left .hoi-poi-ui__tabs-tab-next': {
        bottom: '0 !important'
      },
      '& .hoi-poi-ui__tabs-top .hoi-poi-ui__tabs-tab-arrow-show': {
        opacity: '1',
        width: '32px !important',
        height: '100% !important'
      },
      '& .hoi-poi-ui__tabs-left .hoi-poi-ui__tabs-tab-arrow-show': {
        opacity: '1',
        width: '100% !important',
        height: '32px !important'
      },
      '& .hoi-poi-ui__tabs-bottom .hoi-poi-ui__tabs-tab-arrow-show': {
        opacity: '1',
        width: '100% !important',
        height: '32px !important'
      },
      '& .hoi-poi-ui__tabs-right .hoi-poi-ui__tabs-tab-arrow-show': {
        opacity: '1',
        width: '100% !important',
        height: '32px !important'
      },
      '& .hoi-poi-ui__tabs-left .hoi-poi-ui__tabs-tab-next-icon': {
        transform: 'rotate(90deg)',
        filter: 'progid:DXImageTransform.Microsoft.BasicImage(rotation=1)'
      },
      '& .hoi-poi-ui__tabs-left .hoi-poi-ui__tabs-tab-next-icon:before': {
        content: 'url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTBweCIgaGVpZ2h0PSIxMHB4IiB2aWV3LWJveD0iMCAwIDEwIDEwIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPjxwYXRoIHRyYW5zZm9ybT0icm90YXRlKDI3MCwgNSwgNSkiIGQ9Ik01IDUuODM2bDMuNjctMy4yMTJhLjUuNSAwIDAgMSAuNjYuNzUyTDUuMzM0IDYuODcyYS40OTkuNDk5IDAgMCAxLS42NyAwTC42NzEgMy4zNzZhLjUuNSAwIDAgMSAuNjU4LS43NTJMNSA1LjgzNnoiIGZpbGw9IiM3ODg1OTAiIGZpbGxSdWxlPSJldmVub2RkIj48L3BhdGg+PC9zdmc+)'
      },
      '& .hoi-poi-ui__tabs-left .hoi-poi-ui__tabs-tab-prev-icon': {
        transform: 'rotate(270deg)',
        filter: 'progid:DXImageTransform.Microsoft.BasicImage(rotation=3)'
      },
      '& .hoi-poi-ui__tabs-left .hoi-poi-ui__tabs-tab-prev-icon:before': {
        content: 'url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTBweCIgaGVpZ2h0PSIxMHB4IiB2aWV3LWJveD0iMCAwIDEwIDEwIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPjxwYXRoIHRyYW5zZm9ybT0icm90YXRlKDkwLCA1LCA1KSIgZD0iTTUgNS44MzZsMy42Ny0zLjIxMmEuNS41IDAgMCAxIC42Ni43NTJMNS4zMzQgNi44NzJhLjQ5OS40OTkgMCAwIDEtLjY3IDBMLjY3MSAzLjM3NmEuNS41IDAgMCAxIC42NTgtLjc1Mkw1IDUuODM2eiIgZmlsbD0iIzc4ODU5MCIgZmlsbFJ1bGU9ImV2ZW5vZGQiPjwvcGF0aD48L3N2Zz4=)'
      },
      '& .hoi-poi-ui__tabs-left .hoi-poi-ui__tabs-ink-bar': {
        width: '2px',
        right: 0,
        top: 0
      },
      '& .hoi-poi-ui__tabs-left .hoi-poi-ui__tabs-tab': {
        padding: '16px 24px'
      },
      '& .hoi-poi-ui__tabs-right': {
        borderLeft: "2px solid ".concat(theme.colors.placeholders)
      },
      '& .hoi-poi-ui__tabs-right .hoi-poi-ui__tabs-bar': {
        float: 'right',
        height: '100%',
        marginLeft: '10px'
      },
      '& .hoi-poi-ui__tabs-right .hoi-poi-ui__tabs-nav-container': {
        height: '100%'
      },
      '& .hoi-poi-ui__tabs-right .hoi-poi-ui__tabs-nav-container-scrolling': {
        paddingTop: '32px',
        paddingBottom: '32px'
      },
      '& .hoi-poi-ui__tabs-right .hoi-poi-ui__tabs-nav-wrap': {
        height: '100%'
      },
      '& .hoi-poi-ui__tabs-right .hoi-poi-ui__tabs-nav-scroll': {
        height: '99999px'
      },
      '& .hoi-poi-ui__tabs-right .hoi-poi-ui__tabs-nav-swipe': {
        position: 'relative'
      },
      '& .hoi-poi-ui__tabs-right .hoi-poi-ui__tabs-nav-swipe .hoi-poi-ui__tabs-nav': {
        display: 'flex',
        MsFlex: 1,
        flex: 1,
        MsFlexDirection: 'column',
        flexDirection: 'column',
        height: '100%'
      },
      '& .hoi-poi-ui__tabs-right .hoi-poi-ui__tabs-nav-swipe .hoi-poi-ui__tabs-nav .hoi-poi-ui__tabs-tab': {
        display: 'flex',
        MsFlexNegative: 0,
        flexShrink: 0,
        MsFlexPack: 'center',
        justifyContent: 'center'
      },
      '& .hoi-poi-ui__tabs-right .hoi-poi-ui__tabs-tab-prev': {
        top: '2px !important'
      },
      '& .hoi-poi-ui__tabs-right .hoi-poi-ui__tabs-tab-next': {
        bottom: '0 !important'
      },
      '& .hoi-poi-ui__tabs-right .hoi-poi-ui__tabs-tab-next-icon': {
        transform: 'rotate(90deg)',
        filter: 'progid:DXImageTransform.Microsoft.BasicImage(rotation=1)'
      },
      '& .hoi-poi-ui__tabs-right .hoi-poi-ui__tabs-tab-next-icon:before': {
        content: 'url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTBweCIgaGVpZ2h0PSIxMHB4IiB2aWV3LWJveD0iMCAwIDEwIDEwIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPjxwYXRoIHRyYW5zZm9ybT0icm90YXRlKDI3MCwgNSwgNSkiIGQ9Ik01IDUuODM2bDMuNjctMy4yMTJhLjUuNSAwIDAgMSAuNjYuNzUyTDUuMzM0IDYuODcyYS40OTkuNDk5IDAgMCAxLS42NyAwTC42NzEgMy4zNzZhLjUuNSAwIDAgMSAuNjU4LS43NTJMNSA1LjgzNnoiIGZpbGw9IiM3ODg1OTAiIGZpbGxSdWxlPSJldmVub2RkIj48L3BhdGg+PC9zdmc+)'
      },
      '& .hoi-poi-ui__tabs-right .hoi-poi-ui__tabs-tab-prev-icon': {
        transform: 'rotate(270deg)',
        filter: 'progid:DXImageTransform.Microsoft.BasicImage(rotation=3)'
      },
      '& .hoi-poi-ui__tabs-right .hoi-poi-ui__tabs-tab-prev-icon:before': {
        content: 'url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTBweCIgaGVpZ2h0PSIxMHB4IiB2aWV3LWJveD0iMCAwIDEwIDEwIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPjxwYXRoIHRyYW5zZm9ybT0icm90YXRlKDkwLCA1LCA1KSIgZD0iTTUgNS44MzZsMy42Ny0zLjIxMmEuNS41IDAgMCAxIC42Ni43NTJMNS4zMzQgNi44NzJhLjQ5OS40OTkgMCAwIDEtLjY3IDBMLjY3MSAzLjM3NmEuNS41IDAgMCAxIC42NTgtLjc1Mkw1IDUuODM2eiIgZmlsbD0iIzc4ODU5MCIgZmlsbFJ1bGU9ImV2ZW5vZGQiPjwvcGF0aD48L3N2Zz4=)'
      },
      '& .hoi-poi-ui__tabs-right .hoi-poi-ui__tabs-content-animated': {
        MsFlexDirection: 'column',
        flexDirection: 'column'
      },
      '& .hoi-poi-ui__tabs-right .hoi-poi-ui__tabs-content-animated .hoi-poi-ui__tabs-tabpane': {
        height: '100%'
      },
      '& .hoi-poi-ui__tabs-right .hoi-poi-ui__tabs-ink-bar': {
        width: '2px',
        left: 0,
        top: 0
      },
      '& .hoi-poi-ui__tabs-right .hoi-poi-ui__tabs-tab': {
        padding: '16px 24px'
      },
      '& .hoi-poi-ui__tabs-bottom': {
        borderTop: "2px solid ".concat(theme.colors.placeholders)
      },
      '& .hoi-poi-ui__tabs-bottom .hoi-poi-ui__tabs-content': {
        width: '100%'
      },
      '& .hoi-poi-ui__tabs-bottom .hoi-poi-ui__tabs-nav-container-scrolling': {
        paddingLeft: '32px',
        paddingRight: '32px'
      },
      '& .hoi-poi-ui__tabs-bottom .hoi-poi-ui__tabs-nav-scroll': {
        width: '99999px'
      },
      '& .hoi-poi-ui__tabs-bottom .hoi-poi-ui__tabs-nav-swipe': {
        position: 'relative',
        left: 0
      },
      '& .hoi-poi-ui__tabs-bottom .hoi-poi-ui__tabs-nav-swipe .hoi-poi-ui__tabs-nav': {
        display: 'flex',
        MsFlex: 1,
        flex: 1,
        width: '100%'
      },
      '& .hoi-poi-ui__tabs-bottom .hoi-poi-ui__tabs-nav-swipe .hoi-poi-ui__tabs-nav .hoi-poi-ui__tabs-tab': {
        display: 'flex',
        MsFlexNegative: 0,
        flexShrink: 0,
        marginRight: 0,
        padding: '8px 0',
        MsFlexPack: 'center',
        justifyContent: 'center'
      },
      '& .hoi-poi-ui__tabs-bottom .hoi-poi-ui__tabs-nav-wrap': {
        width: '100%'
      },
      '& .hoi-poi-ui__tabs-bottom .hoi-poi-ui__tabs-content-animated': {
        MsFlexDirection: 'row',
        flexDirection: 'row'
      },
      '& .hoi-poi-ui__tabs-bottom .hoi-poi-ui__tabs-content-animated .hoi-poi-ui__tabs-tabpane': {
        width: '100%'
      },
      '& .hoi-poi-ui__tabs-bottom .hoi-poi-ui__tabs-tab-next': {
        marginRight: '-2px',
        width: '32px',
        height: '100%',
        top: 0,
        textAlign: 'center'
      },
      '& .hoi-poi-ui__tabs-bottom .hoi-poi-ui__tabs-tab-next-icon:before': {
        content: 'url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTBweCIgaGVpZ2h0PSIxMHB4IiB2aWV3LWJveD0iMCAwIDEwIDEwIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPjxwYXRoIHRyYW5zZm9ybT0icm90YXRlKDI3MCwgNSwgNSkiIGQ9Ik01IDUuODM2bDMuNjctMy4yMTJhLjUuNSAwIDAgMSAuNjYuNzUyTDUuMzM0IDYuODcyYS40OTkuNDk5IDAgMCAxLS42NyAwTC42NzEgMy4zNzZhLjUuNSAwIDAgMSAuNjU4LS43NTJMNSA1LjgzNnoiIGZpbGw9IiM3ODg1OTAiIGZpbGxSdWxlPSJldmVub2RkIj48L3BhdGg+PC9zdmc+)'
      },
      '& .hoi-poi-ui__tabs-bottom .hoi-poi-ui__tabs-tab-prev': {
        marginRight: '-2px',
        width: '32px',
        height: '100%',
        top: 0,
        textAlign: 'center'
      },
      '& .hoi-poi-ui__tabs-bottom .hoi-poi-ui__tabs-tab-prev-icon:before': {
        content: 'url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTBweCIgaGVpZ2h0PSIxMHB4IiB2aWV3LWJveD0iMCAwIDEwIDEwIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPjxwYXRoIHRyYW5zZm9ybT0icm90YXRlKDkwLCA1LCA1KSIgZD0iTTUgNS44MzZsMy42Ny0zLjIxMmEuNS41IDAgMCAxIC42Ni43NTJMNS4zMzQgNi44NzJhLjQ5OS40OTkgMCAwIDEtLjY3IDBMLjY3MSAzLjM3NmEuNS41IDAgMCAxIC42NTgtLjc1Mkw1IDUuODM2eiIgZmlsbD0iIzc4ODU5MCIgZmlsbFJ1bGU9ImV2ZW5vZGQiPjwvcGF0aD48L3N2Zz4=)'
      },
      '& .hoi-poi-ui__tabs-bottom .hoi-poi-ui__tabs-ink-bar': {
        height: '2px',
        top: '3px',
        left: 0
      },
      '& .hoi-poi-ui__tabs-bottom .hoi-poi-ui__tabs-tab': {
        float: 'left',
        height: '100%',
        marginRight: '20px'
      },
      '& .hoi-poi-ui__tabs-bottom .hoi-poi-ui__tabs-tabpane-inactive': {
        height: 0,
        overflow: 'visible'
      },
      '& .hoi-poi-ui__tabs-top .hoi-poi-ui__tabs-content': {
        width: '100%'
      },
      '& .hoi-poi-ui__tabs-top .hoi-poi-ui__tabs-nav-container-scrolling': {
        paddingLeft: '32px',
        paddingRight: '32px'
      },
      '& .hoi-poi-ui__tabs-top .hoi-poi-ui__tabs-nav-scroll': {
        width: '99999px'
      },
      '& .hoi-poi-ui__tabs-top .hoi-poi-ui__tabs-nav-swipe': {
        position: 'relative',
        left: 0
      },
      '& .hoi-poi-ui__tabs-top .hoi-poi-ui__tabs-nav-swipe .hoi-poi-ui__tabs-nav': {
        display: 'flex',
        MsFlex: 1,
        flex: 1,
        width: '100%'
      },
      '& .hoi-poi-ui__tabs-top .hoi-poi-ui__tabs-nav-swipe .hoi-poi-ui__tabs-nav .hoi-poi-ui__tabs-tab': {
        display: 'flex',
        MsFlexNegative: 0,
        flexShrink: 0,
        marginRight: 0,
        padding: '8px 0',
        MsFlexPack: 'center',
        justifyContent: 'center'
      },
      '& .hoi-poi-ui__tabs-top .hoi-poi-ui__tabs-nav-wrap': {
        width: '100%'
      },
      '& .hoi-poi-ui__tabs-top .hoi-poi-ui__tabs-content-animated': {
        MsFlexDirection: 'row',
        flexDirection: 'row'
      },
      '& .hoi-poi-ui__tabs-top .hoi-poi-ui__tabs-content-animated .hoi-poi-ui__tabs-tabpane': {
        width: '100%'
      },
      '& .hoi-poi-ui__tabs-top .hoi-poi-ui__tabs-tab-next': {
        marginRight: '-2px',
        width: 0,
        height: 0,
        top: 0,
        textAlign: 'center',
        transition: 'width .3s, height .3s, opacity .3s',
        right: 0
      },
      '& .hoi-poi-ui__tabs-top .hoi-poi-ui__tabs-tab-next-icon:before': {
        content: 'url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTBweCIgaGVpZ2h0PSIxMHB4IiB2aWV3LWJveD0iMCAwIDEwIDEwIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPjxwYXRoIHRyYW5zZm9ybT0icm90YXRlKDI3MCwgNSwgNSkiIGQ9Ik01IDUuODM2bDMuNjctMy4yMTJhLjUuNSAwIDAgMSAuNjYuNzUyTDUuMzM0IDYuODcyYS40OTkuNDk5IDAgMCAxLS42NyAwTC42NzEgMy4zNzZhLjUuNSAwIDAgMSAuNjU4LS43NTJMNSA1LjgzNnoiIGZpbGw9IiM3ODg1OTAiIGZpbGxSdWxlPSJldmVub2RkIj48L3BhdGg+PC9zdmc+)'
      },
      '& .hoi-poi-ui__tabs-top .hoi-poi-ui__tabs-tab-prev': {
        marginRight: '-2px',
        width: 0,
        height: 0,
        top: 0,
        textAlign: 'center',
        transition: 'width .3s, height .3s, opacity .3s',
        left: 0
      },
      '& .hoi-poi-ui__tabs-top .hoi-poi-ui__tabs-tab-prev-icon:before': {
        content: 'url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTBweCIgaGVpZ2h0PSIxMHB4IiB2aWV3LWJveD0iMCAwIDEwIDEwIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPjxwYXRoIHRyYW5zZm9ybT0icm90YXRlKDkwLCA1LCA1KSIgZD0iTTUgNS44MzZsMy42Ny0zLjIxMmEuNS41IDAgMCAxIC42Ni43NTJMNS4zMzQgNi44NzJhLjQ5OS40OTkgMCAwIDEtLjY3IDBMLjY3MSAzLjM3NmEuNS41IDAgMCAxIC42NTgtLjc1Mkw1IDUuODM2eiIgZmlsbD0iIzc4ODU5MCIgZmlsbFJ1bGU9ImV2ZW5vZGQiPjwvcGF0aD48L3N2Zz4=)'
      },
      '& .hoi-poi-ui__tabs-top .hoi-poi-ui__tabs-ink-bar': {
        height: '2px',
        bottom: 0,
        left: 0
      },
      '& .hoi-poi-ui__tabs-top .hoi-poi-ui__tabs-tab': {
        float: 'left',
        height: '100%',
        marginRight: '20px'
      },
      '& .hoi-poi-ui__tabs-top .hoi-poi-ui__tabs-tabpane-inactive': {
        height: 0,
        overflow: 'visible'
      }
    },
    withPostComponent: {
      display: 'flex',
      alignItems: 'center'
    },
    postComponent: {}
  };
};

exports.default = _default;